import { FC } from 'react';
import s from './stepper.module.css';

import cn from 'classnames';
import { useLang } from '../../hooks/use-lang';

interface Props {
  current: number;
  totalSteps: number;
  type?: 'count' | 'progress';
}

export const Stepper: FC<Props> = ({ current, totalSteps, type = 'progress' }) => {
  const { t } = useLang();

  return (
    <ul className={s.component}>
      {type === 'count' && (
        <li className={s.step}>
          {t('Шаг')} {current + 1}/{totalSteps}
        </li>
      )}

      {type === 'progress' &&
        Array.from({ length: totalSteps }).map((_, i) => (
          <li key={i} className={cn(s.item, i === current && s.outline, current > i && s.filled)}>
            <div className={s.circle} />
            {i < totalSteps - 1 && <div className={s.line} />}
          </li>
        ))}
    </ul>
  );
};
